module.exports = __webpack_public_path__ + "img/ebook.c24bd82c.png";